import PropTypes from 'prop-types'
import { Card, CardContent, CardHeader, Skeleton, Stack, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { Chart } from 'src/components/chart'
import { breedLabel } from 'src/utils/breed-labels'

/**
 * 犬種別の購入数ランキング（上位10件）。
 * 犬種名はジェネレーターのカタログ由来のため、未知のIDはそのままIDで表示される。
 */
const useChartOptions = (categories) => {
  const theme = useTheme()

  return {
    chart: { background: 'transparent', toolbar: { show: false } },
    colors: [theme.palette.info.main],
    dataLabels: { enabled: true, style: { colors: [theme.palette.common.white] } },
    grid: {
      borderColor: theme.palette.divider,
      strokeDashArray: 2,
      xaxis: { lines: { show: true } },
      yaxis: { lines: { show: false } },
    },
    plotOptions: { bar: { horizontal: true, borderRadius: 3, barHeight: '65%' } },
    theme: { mode: theme.palette.mode },
    tooltip: { y: { formatter: (v) => `${v.toLocaleString()} 件` } },
    xaxis: {
      categories,
      // 件数は整数なので小数目盛りを出さない
      labels: { style: { colors: theme.palette.text.secondary }, formatter: (v) => `${Math.round(v)}` },
      tickAmount: 4,
    },
    yaxis: { labels: { style: { colors: theme.palette.text.secondary } } },
  }
}

export const PatternBreedRanking = (props) => {
  const { breeds = [], loading = false } = props

  // 上位が上に来るよう反転する（Apex の横棒は下から積まれる）
  const ordered = [...breeds].reverse()
  const categories = ordered.map((b) => breedLabel(b.breedId))
  const options = useChartOptions(categories)
  const series = [{ name: '購入数', data: ordered.map((b) => b.count) }]

  return (
    <Card sx={{ height: '100%' }}>
      <CardHeader title="犬種別ランキング" subheader="購入時に選択された犬種（上位10件）" />
      <CardContent>
        {loading ? (
          <Skeleton variant="rectangular" height={350} />
        ) : breeds.length === 0 ? (
          <Stack alignItems="center" justifyContent="center" sx={{ height: 350 }}>
            <Typography color="text.secondary" variant="body2">
              この期間のデータがありません
            </Typography>
          </Stack>
        ) : (
          <Chart height={350} options={options} series={series} type="bar" width="100%" />
        )}
      </CardContent>
    </Card>
  )
}

PatternBreedRanking.propTypes = {
  breeds: PropTypes.array,
  loading: PropTypes.bool,
}
